<template>
    <v-card flat style="border-top: 1px solid lightgray">
        <v-overlay :value="loadingClientList">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-data-table
            :items-per-page="50"
            :footer-props="footerProps"
            :options.sync="options"
            :server-items-length="totalClientCount"
            :search="searchClientString"
            class="product-table"
            dense
            :headers="clientTableHeaders"
            :items="clients"
        >
            <template v-for="h in clientTableHeaders" v-slot:[`header.${h.value}`]="{ header }">
                <span :class="'text-' + header.align">{{ header.text ? t(header.text) : "-" }}</span>
            </template>
            <template v-slot:item="{ item }">
                <tr
                    :key="'contact_' + item.id"
                    @click="handleTableRowClick(item)"
                    :class="{
                        activeTableRow: activeClient && parseInt(item.id) === parseInt(activeClient.id)
                    }"
                >
                    <td
                        v-for="(row, index) in clientTableHeaders"
                        :class="{
                            lastColumn: index === clientTableHeaders.length - 1 && clientTableHeaders.length > 2,
                            penultimateColumn: index === clientTableHeaders.length - 2 && clientTableHeaders.length > 2
                        }"
                    >
                        <span v-if="row.value === 'flag'"
                            ><country-flag v-if="item.country_code" :country="item.country_code" size="small"
                        /></span>

                        <span v-else-if="row.value === 'region'">{{
                            item.region ? t(item.region.charAt(0).toUpperCase() + item.region.slice(1)) : "-"
                        }}</span>
                        <span v-else-if="row.value === 'country'">{{ getItemCountry(item) }}</span>
                        <span v-else>{{ item[row.value] ? item[row.value] : "-" }}</span>
                    </td>
                </tr>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import Store from "@/store";
import { mapState, mapGetters } from "vuex";
import CountryFlag from "vue-country-flag";
import { PermissionsConstants } from "@/permissions";

export default {
    name: "client-list",
    components: {
        CountryFlag
    },
    data() {
        return {
            footerProps: { "items-per-page-options": [25, 50, 100] },
            options: this.tableOptions
        };
    },
    mounted() {
        //Store.dispatch("ExportClientStore/callGetClientsList");
    },
    computed: {
        ...mapState("ExportClientStore", [
            "searchClientString",
            "loadingClientList",
            "activeClient",
            "clients",
            "tableOptions",
            "clientTableHeaders",
            "totalClientCount"
        ]),
        ...mapState(["user"]),
        ...mapGetters("ExportClientStore", ["clientCount"]),
        ...mapGetters(["hasPermissionForAction"]),
        PermissionsConstants() {
            return PermissionsConstants;
        }
    },
    watch: {
        options(val) {
            Store.commit("ExportClientStore/setTableOptions", val);
        }
    },
    methods: {
        handleTableRowClick(client) {
            if (!this.hasPermissionForAction(PermissionsConstants.EXPORT_CLIENT, PermissionsConstants.VIEW)) {
                return;
            }
            if (this.$route.name !== "export-client-view") {
                this.$router.push({ name: "export-client-view", params: { clientId: client.id } });

                return;
            }
            if (
                this.$route.name === "export-client-view" &&
                parseInt(client.id) !== parseInt(this.$route.params.clientId)
            ) {
                this.$router.push({ name: "export-client-view", params: { clientId: client.id } });
                Store.dispatch("ExportClientStore/getClientData", client.id);
            }
        },
        getItemCountry(item) {
            if (item.country_estonian) {
                return item.country_estonian;
            }
            if (item.country_english) {
                return item.country_english;
            }
            return "-";
        }
    }
};
</script>

<style scoped>
.lastColumn {
    text-align: center;
}
.penultimateColumn {
    text-align: end;
}
::v-deep .v-data-table-header th {
    white-space: nowrap;
}
td {
    height: 25px !important;
}
</style>
